import {
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from "@angular/core";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { CsIconModule } from "@components/icon";
import { Catalog } from "@cureskin/api-client/src/server-api";

@Component({
  selector: "app-product",
  imports: [CsIconModule, ButtonCtaComponent],
  templateUrl: "./product.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 120px;
        min-width: 120px;
      }
    `,
  ],
  standalone: true
})
export class ProductComponent {
  product: InputSignal<any> = input();
  productInCart: InputSignal<any> = input();
  isShopRevampExperimentOn: InputSignal<boolean> = input();
  gotoProduct: OutputEmitterRef<Catalog> = output();
  addToCart: OutputEmitterRef<{ product: Catalog; image: HTMLImageElement }> =
    output();
  reomveFromCart: OutputEmitterRef<Catalog> = output();

  productImage: Signal<string> = computed(
    () =>
      this.product()?.rebrandedImageWithBackground?.[0] ||
      this.product()?.productUnboxedImage?.[0] ||
      this.product()?.images?.[0] ||
      this.product()?.productImage
  );
  productTitle: Signal<string> = computed(() => this.product()?.title);

  productQuantity: Signal<number> = computed(() => {
    if (!this.productInCart()) return 0;

    // If productInCart is an object with quantity property
    if (
      typeof this.productInCart() === "object" &&
      this.productInCart()?.quantity !== undefined
    ) {
      return this.productInCart().quantity;
    }

    // If productInCart is just a number
    if (typeof this.productInCart() === "number") {
      return this.productInCart();
    }

    return 0;
  });

  addToCartAction(product: Catalog, image: HTMLImageElement): void {
    this.addToCart.emit({ product, image });
  }

  removeFromCartAction(product: any): void {
    this.reomveFromCart.emit(product);
  }
}
